/* import __COLOCATED_TEMPLATE__ from './buffer-zone-option.hbs'; */
import templateOnlyComponent from '@ember/component/template-only';

export interface FiltersBufferZoneOptionSignature {
  Args: {
    hideCount?: boolean;
    option: unknown;
  };
  Element: HTMLElement;
}

const FiltersBufferZoneOptionComponent = templateOnlyComponent<FiltersBufferZoneOptionSignature>();

export default FiltersBufferZoneOptionComponent;

declare module '@glint/environment-ember-loose/registry' {
  export default interface Registry {
    'Filters::BufferZoneOption': typeof FiltersBufferZoneOptionComponent;
    'filters/buffer-zone-option': typeof FiltersBufferZoneOptionComponent;
  }
}
